<script setup lang="ts">
const showPopup = defineModel('showPopup');
const formChoose = defineModel('formChoose');
const toLogin = () => {
  showPopup.value = false;
  formChoose.value = 'LoginForm';
};
const forgetPassword = () => {
  showPopup.value = false;
  formChoose.value = 'ForgetPassword';
};
</script>
<template>
  <div class="wrong-sex-card">
    <p>重複註冊</p>
    <p class="hint">
      很抱歉，你的帳號/手機已經註冊過了。請直接<span @click="toLogin">登入</span>或點擊<span
        @click="forgetPassword"
        >忘記密碼</span
      >查詢
    </p>

    <button @click="showPopup = false">確定</button>
  </div>
</template>
<style scoped lang="scss">
.wrong-sex-card {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 290px;
  padding: 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  align-items: center;
  justify-content: space-between;
  p {
    color: $txt-color-grey-80;
    font-size: 18px;
    font-weight: 600;
    width: 100%;
  }
  .hint {
    color: $txt-color-grey-40;
    font-size: 14px;
    margin-top: 4px;
    margin-bottom: 16px;
    line-height: 19.6px;
    span {
      color: #f74768;
      position: relative;
      cursor: pointer;
      &:hover {
        &:after {
          content: '';
          width: 100%;
          bottom: -2px;
          left: 0;
          height: 1px;
          background-color: #f74768;
          position: absolute;
        }
      }
    }
  }
  button {
    width: 100%;
    border: none;
    background-color: #f74768;
    color: #ffffff;
    font-size: 16px;
    border-radius: 4px;
    padding: 8px 24px;
    cursor: pointer;
  }
}

.junior-landing-page > .main-content > .popup-overlay > .wrong-sex-card {
  > button {
    background-color: $color-brownish-100;
  }

  .hint {
    span {
      color: $color-brownish-100;
      &:hover {
        &:after {
          background-color: $color-brownish-100;
        }
      }
    }
  }
}
</style>
